import { render } from "./Curr.vue?vue&type=template&id=61ec6e08"
import script from "./Curr.vue?vue&type=script&lang=js"
export * from "./Curr.vue?vue&type=script&lang=js"
script.render = render

export default script